import { render } from "./VehicleEdit.vue?vue&type=template&id=853e5bb6"
import script from "./VehicleEdit.vue?vue&type=script&lang=js"
export * from "./VehicleEdit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/furkanyesil/Projects/fair-mieten-mg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__